import type { ShallowRef } from 'vue';
import type { OpenBlockOptions } from '#layers/block-engine/composables/use-block-editor';
import type { BlockRootContext } from '#layers/block-engine/types/block';
import { toValue } from 'vue';

export function useBlockEditorRootContext({
	options,
}: {
	options: ShallowRef<OpenBlockOptions | null>;
}) {
	function getRootContextValues() {
		const result: Record<string, any> = {};

		if (options.value?.contextProperties) {
			for (const [key, property] of Object.entries(options.value.contextProperties)) {
				result[key] = toValue(property.value);
			}
		}

		return result as BlockRootContext;
	}

	return {
		getRootContextValues,
	};
}

export type BlockEditorRootContext = ReturnType<typeof useBlockEditorRootContext>;
